import { APIProvider, ControlPosition, Map, Marker } from "@vis.gl/react-google-maps";
import { Fragment, useState } from "react";
import MapHandler from "./map-handler";
import { CustomMapControl } from "./map-control";

interface inputPrams {
  locationGps: string;
  locationLabel: string;
  setLocationGps: React.Dispatch<string>;
  setLocationLabel: React.Dispatch<string>;
}

const API_KEY = "AIzaSyB4m5Hx4i4F8ip8TG9hfuqZCNJ11J05Y_M";

export default function GoogleMapsViewV2(props: inputPrams) {
  const locationGps = props.locationGps?.split(",");

  let latitude = 0;
  let longitude = 0;

  if (locationGps && locationGps.length === 2) {
    // Ensure both latitude and longitude are valid numbers
    latitude = +locationGps[0] || 0;
    longitude = +locationGps[1] || 0;
  }

  const [location, setLocation] = useState({
    lat: latitude,
    lng: longitude,
  } as google.maps.LatLngLiteral);
  const [selectedPlace, setSelectedPlace] = useState<google.maps.places.PlaceResult | null>(null);

  // Works but once changed the map viewport does not go to location, think have to use `map.fitBounds(` but needs to be in hook then
  // function getCurrentPositionSuccess(position: any) {
  //   latitude = position.coords.latitude;
  //   longitude = position.coords.longitude;
  //   if (location.lat === 0) {
  //     setLocation({
  //       lat: latitude,
  //       lng: longitude
  //     });
  //   }
  //   // console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
  // }
  // function getCurrentPositionError() {
  //   console.log("Unable to retrieve your location");
  // }
  // if (latitude === 0 && longitude === 0 && navigator.geolocation) {
  //   navigator.geolocation.getCurrentPosition(getCurrentPositionSuccess, getCurrentPositionError);
  // }

  function positionChange(loc: google.maps.LatLngLiteral) {
    // console.log("positionChange == ", loc);
    setLocation(loc);
    props.setLocationGps(`${loc.lat},${loc.lng}`);
  }

  function positionAddressChange(e: any) {
    // console.log("positionAddressChange == ", e);
    setSelectedPlace(e);
  }

  return (
    <Fragment>
      <APIProvider apiKey={API_KEY}>
        <Map
          style={{ height: "50vh", minHeight: "500px" }}
          defaultZoom={location.lat === 0 && location.lng === 0 ? 2 : 15}
          defaultCenter={location}
          gestureHandling={"greedy"}
          disableDefaultUI={true}
        >
          <Marker
            position={location}
            clickable={true}
            draggable={true}
            onDrag={e => {
              if (e.latLng) {
                positionChange({ lat: e.latLng.lat(), lng: e.latLng.lng() });
              }
            }}
          />
        </Map>
        <CustomMapControl
          location={location}
          setGps={positionChange}
          setAddress={props.setLocationLabel}
          controlPosition={ControlPosition.TOP}
          onPlaceSelect={positionAddressChange}
        />
        <MapHandler place={selectedPlace} />
      </APIProvider>
    </Fragment>
  );
}
